<template>
  <div class="route-scroll">
    <search
      v-if="false"
      autofocus
      v-model="queryParams.keywords"
      placeholder="请输入搜索关键词"
      @search="refreshList"
    />

    <pull-refresh v-model="pullLoading" @refresh="refreshList">
      <list v-model="loading" :finished="!hasNext" finished-text="没有更多了" @load="loadList" :immediate-check="false">
        <div style="text-align: center; padding: 10vh 0" v-if="listInfo.length == 0 && !loading"></div>
        <div v-for="product in listInfo" :key="product.id" class="product-item" @click="toDeatil(product.drugsId)">
          <div class="product-img">
            <van-image v-if="product.drugsImage" :src="product.drugsImage.split(',')[0]" fit="cover" />
          </div>
          <div class="product-info">
            <drugTag :product="product" />
            <p class="product-points">
              <pointPrice :product="product" />
            </p>
          </div>
          <div class="add-to-cart" @click.stop="addToCart(product)">
            <van-icon name="add" size="22" color="#00bdd4" />
          </div>
        </div>
      </list>
    </pull-refresh>
  </div>
</template>

<script>
import pointPrice from '@/components/pointPrice';
import drugTag from '@/components/drugTag';
import { Search, PullRefresh, List, Icon, Image as VanImage } from 'vant';
import services from '@/service';
import { userPointsTypeAll, userPointsFlowChannelAll } from '@/enum/index';

export default {
  name: 'mallCategoryList',
  components: { pointPrice, drugTag, Search, PullRefresh, List, [Icon.name]: Icon, [VanImage.name]: VanImage },
  data() {
    return {
      items: [],
      pullLoading: false,
      loading: false,
      hasNext: true,
      queryParams: {
        pageNum: 0,
        pageSize: 10,
        keywords: ''
      },
      listInfo: [],
      userPointsTypeAll,
      userPointsFlowChannelAll
    };
  },
  computed: {
    navId() {
      return this.$route.query.navId || '';
    }
  },
  methods: {
    realPrice(goods) {
      return (goods.price - goods.memberDeduction).toFixed(2);
    },
    async refreshList() {
      this.pullLoading = true;
      this.listInfo = [];
      this.queryParams.pageNum = 0;
      this.hasNext = false;
      setTimeout(() => {
        this.loadList();
      }, 500);
    },
    async loadList() {
      this.queryParams.pageNum++;
      // 接口改为根据navId查列表
      const res = await services.mall.getDrugsNav(this.navId, this.queryParams);
      this.listInfo = [...this.listInfo, ...res.rows];
      this.hasNext = this.listInfo.length < res.total;
      this.pullLoading = false;
      this.loading = false;
    },
    async addToCart(product) {
      const params = {
        goodsId: product.drugsId,
        number: 1,
        goodsName: product.name,
        salePrice: product.price,
        goodsIcon: product.drugsImage,
        addOrDeduct: 1
      };
      await services.mall.addMallCart(params);
      this.$toast('加入购物车成功');
    },
    toDeatil(id) {
      this.$router.push({
        name: 'mallProductDetail',
        query: { id }
      });
    }
  },
  mounted() {
    this.refreshList();
  }
};
</script>

<style lang="scss" scoped>
.product-item:not(:last-child) {
  border-bottom: 1px solid $bordercolor;
}

.product-item {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 12px $lr;

  .product-img {
    width: 80px;
    height: 80px;
    margin-right: 12px;
    border-radius: $radius;
    overflow: hidden;

    .van-image {
      width: 100%;
      height: 100%;
    }
  }

  .product-info {
    flex: 1;

    .product-points {
      font-size: 12px;
      color: $gray2;

      .points {
        font-size: 12px;
        color: $gray1;
      }

      .price {
        font-size: $size5;
        color: $red1;
        font-weight: 500;
      }
    }
  }

  .add-to-cart {
    cursor: pointer;
  }
}
</style>
